var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .562)",
    fill: "#FAA100",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fillOpacity: 0.1,
    cx: 29.987,
    cy: 30,
    rx: 29.987,
    ry: 30
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.307 23.657v3.369l2.153-1.59zM31.22 16.18a2.063 2.063 0 0 0-2.618-.008l-.868.734h4.368l-.882-.727z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.952 34.89a3.366 3.366 0 0 1-2.03.666c-.732 0-1.45-.23-2.038-.665l-10.891-8.076v13.849a2.039 2.039 0 0 0 2.03 2.044H40.8a2.039 2.039 0 0 0 2.03-2.044V26.815l-10.877 8.076z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.369 25.437 2.085 1.541v-3.26zM20.821 18.264v9.726l7.863 5.814c.731.53 1.737.53 2.468 0l7.787-5.766v-9.774H20.821zm4.855 5.434h3.692c.376 0 .683.305.683.679 0 .374-.307.68-.683.68h-3.692a.683.683 0 0 1-.684-.68c0-.374.308-.68.684-.68zm8.478 4.754h-8.478a.683.683 0 0 1-.684-.679c0-.374.308-.68.684-.68h8.478c.376 0 .683.306.683.68 0 .374-.307.68-.683.68z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.0f6eb861b99d174934d9acb02103b26b.svg";
export { ForwardRef as ReactComponent };